// Google Analytics 4 is loaded by /consent/consent-config.js, only after consent.
// Lead event after a successful form submission; sent only while analytics is active.
export function trackLead(formName, page) {
  if (window.visoplanAnalyticsActive && typeof window.gtag === 'function') {
    window.gtag('event', 'generate_lead', {form_name: formName, page_name: page});
  }
}
